import React, { useState, useEffect, useContext } from "react";
import TextField from "@material-ui/core/TextField";
import { Theme, createStyles, WithStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
// FB 4371 BR:Start    04/29/2021    Bug fix for the issue for DOB
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
// FB 4371 BR:End	04/29/2021    Bug fix for the issue for DOB
import {
  create_patient,
  get_States,
  remove_reg,
  create_appointment,
} from "../actions/index";
import {
  SearchPatient,
  AppointmentCount,
  UpdateEmailCellPhone,
  FetchEmailCellPhone,
  InsertPELogs, //FB 4960
  GetPatientType,  //FB 4959 
  UpdatePatientCommunicationPreference,   //FB 6752
  ConvertTimeZone, //FB 7675
  GetSavedCards //FB 7719
} from "../api/index"; //FB 4780 BR In PE, Getting Email/Cell for Existing Patients
import MuiDialogActions from "@material-ui/core/DialogActions";
import { GetAdminSettingValue } from '../api';//FB 7719
import {
  Grid,
  Button,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
  Dialog,
  DialogContent,
  Typography,
  withStyles,
  NativeSelect,
  //FB 6752
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Context, State } from "../store";
import useStyle from "../css/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { format } from "date-fns";
import Snackbar, { SnackbarOrigin } from "@material-ui/core/Snackbar";
import { Alert } from "@material-ui/lab";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import globalsettings from "../../../config";
//FB 4533 BR- GA to Patient Engagement
import ReactGA from 'react-ga';

// update log
// FB 4371 BR    03/29/2021    Demographics User Interface to accept the patient details
// FB 4371 BR    04/29/2021    Bug fix for the issue for DOB
// FB 4371 BR    04/29/2021    Bug fix for the issue which was creating 2 appointments on button click
// FB 4409 DK    04/30/2021    Added logic to disable the DOB field after existing patient verified
// FB 4499 DK    06/09/2021    Fix for Date of Birth field broken
// FB 4533 BR    07/01/2021    GA tags to Patient Engagement
// FB 4556 DK    07/07/2021    Implement client side error handling on PE
// FB 4574 DK    07/15/2021    Fixed multiple UI issues
// FB 4567 DK    07/12/2021    Modified gender options to sync with carecloud acceptable genders
// FB 4578 DK    07/16/2021    Fixed issue with existing patient appointment booking
// FB 4638 MS    08/31/2021    Fixed Mobile view issues
// FB 4678 MS    08/31/2021    Fixed timer overlap issue
// FB 4680 BR    09/13/2021	   PE - Existing patient workflow issues
// FB 4735 DK    10/11/2021    Implementation of provider specific flow
// FB 4780 BR    11/02/2021    In PE, Getting Email/Cell for Existing Patients
// FB 4816 MS    11/23/2021    Saving city, state, Zip for patient
// FB 4867 DK    12/27/2021    Added screens for Support files and Health forms upload
// FB 4959 MS    03/01/2022    Added condition to hide PI button for existing patients in landing page
// FB 4960 BR    07/03/2022   Logging all actions on PE
// FB 6006 MS    04/05/2022   Added logic to save email/phone of an existing patient in new patient workflow
// FB 4924 GS    06/21/2022   updated email validation to accept gmail accounts with special characters in recipient's name
// FB 6752 DK    05/06/2023    Manage communication preference on PE
// FB 7269 GA    08/31/2023   PE- Book Appointment is not enabled
// FB 7330 GA    09/05/2023   PE - Unable to book appointment for existing patients
// FB 7456 GS    09/22/2023    Issue with Appointment type when booked with telehealth existing patient
// FB 7675 DK    11/09/2023    Timezone handling for appointments
// FB 7801 SK    12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time
// FB 7719 SK    02/13/2024    PE- option to add credit card on file while booking an appointment
// FB 8653 DK    05/08/2024    DOB is set to current date by default
// FB 8917 DK    06/25/2024    Can't create patient without phone number
// FB 9396 MS    09/13/2024    Renamed Book Appitnement Button to Verify for existing patient
// FB 9538 KI    10/22/2024    Make PE Reason for Appt Mandetory
// FB 9505 KI    10/22/2024    Mobile number is hardcode in PE alert
// FB 10954 DK   09/10/2025    Unable to book an appointment from MHA PE – getting an error


export interface SnackBarState extends SnackbarOrigin {
  open: boolean;
}

const reEmail = /^([a-zA-Z0-9_\-\.]+)(?!.*[_./#&+!$%*=?'`{|^_-]{2})([ A-Za-z0-9_./#&+!$%*=?'`{|^_-]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/; //FB-4924

const styless = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styless> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

export default function Demographics() {
  const styles = useStyle();

  const history = useHistory();

  const useStyles = makeStyles({
    active: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      marginLeft: "20px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
    },
    buttonactive: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
      width: "160px",
    },
    inactive: {
      backgroundColor: "white",
      color: "#18a2b8",
      textTransform: "capitalize",
      borderRadius: "15px",
    },
    buttonMargin: {
      marginLeft: "100px",
    },
    datepickerroot: {
      "&.MuiIconButton-root": {
        color: "#18a2b8",
      },
    },
    dropdown_nomargin: {
      "&.MuiFormControl-marginNormal": {
        color: "#18a2b8",
      },
      //FB 4574 DK - Added styling for dropdown icon
      "& .MuiSvgIcon-root": {
        fontSize: "2rem"
      }
    },
    //FB 4574 DK - Added a new class for calender icon
    iconCSS: {
      "& .MuiSvgIcon-root": {
        fontSize: "1.8rem"
      },
      "& .MuiIconButton-root": {
        color: "#18a2b8",
      },
    }
  });

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });

  const classes = useStyles();

  const handleGoBack = () => {
    remove_reg(state.slotDetails.id);
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Demographics");
    //FB 4960 End
    history.goBack();
  };

  const dateOptions = {
    month: "long",
    day: "numeric",
    year: "numeric",
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
  };

  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  //FB 4371: Bindu - Bug fix for the issue for DOB
  const [DOB, setDOB] = useState<any>(null);
  const [Gender, setGender] = useState(0);
  const [Email, setEmail] = useState("");
  const [Address, setAddress] = useState("");
  const [ZipCode, setZipCode] = useState("");
  const [CellPhone, setCellPhone] = useState("");
  const [City, setCity] = useState("");
  const [] = useState("");
  const [Comments, setComments] = useState("");
  const [states, setStates] = React.useState<State[]>([]);
  const [opens] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const { state, dispatch } = useContext(Context);
  const [returnValue, setReturnvalue] = useState(0);
  const [displayvalue, setDisplayvalue] = useState("none");
  const [displayMessage, setDisplaymessage] = useState("none");
  const [disablebutton, setDisablebutton] = useState("none");
  const [] = useState();
  const [statename, setStatename] = useState("");
  const [verifydisplay, setVerifydisplay] = useState("none");
  const [displayVerfiedMessage, SetdisplayVerfiedMessage] = useState("none");
  const [, setCount] = useState(0);
  const [btnDisable, SetBtnDisable] = useState<boolean>(false);
  const [seconds, setSeconds] = useState(0);
  //FB 4574 DK - Increased the time limit to 10 mins
  const [minutesLeft, setMinutesLeft] = useState<any>(10);
  const [navigate, setNavigate] = useState(false);
  const [] = useState(false);
  const [genderMessage, setGenderMessage] = useState("");
  const [stateMessage, setStateMessage] = useState("");
  const [StatesError, setStatesError] = useState(false);
  const [GenderError, setGenderError] = useState(false);
  const [navigation, setNavigation] = useState(false);
  const [navigateWhenNotFound, setnavigateWhenNotFound] = useState(false);
  const [callCreatePatient, setCallCreatePatient] = useState(false);
  const todaysDate = format(new Date(), "yyyy-MM-dd");
  const [disableFields, setDisableFields] = useState(false);
  const [] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [emailMessage, setEmailMessage] = useState("");
  const [CityError, setCityError] = useState(false);
  const [CommentError, setCommentError] = useState(false); //FB 9538
  const [CommentMessage, setCommentMessage] = useState(""); //FB 9538
  const [CityMessage, setCityMessage] = useState("");
  const [AddressError, setAddressError] = useState(false);
  const [AddressMessage, setAddressMessage] = useState("");
  const [CellPhoneError, setCellPhoneError] = useState(false);
  const [CellPhoneMessage, setCellPhoneMessage] = useState("");
  const [firstNameError, setfirstNameError] = useState(false);
  const [firstNameMessage, setfirstNameMessage] = useState("");
  const [lastNameError, setlastNameError] = useState(false);
  const [lastNameMessage, setlastNameMessage] = useState("");
  const [openValidationDialog, setOpenValidationDialog] = useState(false);
  const [patn, setPatn] = useState(0);
  const [DOBError, setDOBError] = useState(false);
  const [DOBMessage, setDOBMessage] = useState("");
  //FB 8653
  const [dateforDOBfield, setDateforDOBfield] = useState<Date>(null as unknown as Date);		//FB 4499 DK - Added to store the date selected from DOB field //FB 7719
  //FB 4780 BR:Start-In PE, Getting Email/Cell for Existing Patients
  const [openUpdateEmailDialog, setOpenUpdateEmailDialog] = React.useState(false);
  const [patientEmail, setPatientEmail] = useState("");
  const [patientCellPhone, setPatientCellPhone] = useState("");
  //FB 6752
  const [emailPref, setEmailPref] = useState<number>(0);
  const [textPref, setTextPref] = useState<number>(0);
  const [showPref, setShowPref] = useState(false);
  const [patientPref, setPatientPref] = useState("");
  const [requireCC, setRequireCC] = useState<number | null>(null); //FB 7719
  const [enableReasonForAppt, setEnableReasonForAppt] = useState(false); //FB 9538

  //FB 4780 BR:Start-In PE, Getting Email/Cell for Existing Patients

  //FB 4867 DK - Formatting phone number
  const normalizeInput = (value: any) => {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;

    if (value.length > 0) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
    }
  };
  //FB 7719 Begin
  async function getadminsettingCCInfo() {
    const data = await GetAdminSettingValue("RequireCCInfo");
    const parsedData = parseFloat(data);
    if (!isNaN(parsedData)) {
      setRequireCC(parsedData);
    }
  }

  //FB 9538 start
  async function getadminsettingEnableReasonForAppt() {
    const data = await GetAdminSettingValue("EnableReasonForAppointment_PE");
    if (data === true) {
      setEnableReasonForAppt(data);
    }
  }
  //FB 9538 end

  const buttonText = requireCC === 1 ? "Next" : "Book Appointment";
  const buttonVerifyText = requireCC === 1 ? "Next" : "Verify"; //FB 9396
  //FB 7719 End

  const [validationObj, setValidationObj] = useState({
    firstNameError: false,
    firstNameMessage: "",
    lastNameError: false,
    lastNameMessage: "",
    emailError: false,
    emailMessage: "",
    cellPhoneError: false,
    cellPhoneMessage: "",
    addressError: false,
    addressMessage: "",
    cityError: false,
    cityMessage: "",
    postalCodeError: false,
    postalCodeMessage: "",
    commentError: false, //FB 9538
    commentMessage: "",	 //FB 9538
    //FB 4371: Bindu:Start - Bug fix for the issue for DOB
    DOBError: false,
    DOBMessage: "",
    //FB 4371: Bindu:End - Bug fix for the issue for DOB
  });

  //FB 4371 BR    03/29/2021    validation flag to navigate to the next page
  const navigationValidation = () => {
    // FB 4924 
    const reName = /^(?=.{1,40}$)[a-zA-Z0-9 ]+(?:[-'\s][a-zA-Z0-9 ]+)*$/;
    //FB 4371: Bindu - Bug fix for the issue for DOB
    var reGoodDate = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;

    if (navigateWhenNotFound == false) {
      setNavigate(false);
    } else {
      setNavigate(true);
    }

    if (navigation == true) {
      if (
        FirstName.length != 0 &&
        LastName.length != 0 &&
        Email.length != 0 &&
        Address.length != 0 &&
        ZipCode.length != 0 &&
        CellPhone.length != 0 &&
        City.length != 0 &&
        (enableReasonForAppt ? Comments.length != 0 : true) && //FB 9538
        statename != "" &&
        //FB 4371: Bindu - Bug fix for the issue for DOB
        DOB != null &&
        Gender != 0 &&
        DOB <= todaysDate &&
        CellPhone.length === 14 &&  //FB-4867
        ZipCode.length === 5 &&
        reEmail.test(Email) &&  //FB-4924
        reName.test(FirstName) &&
        //FB 4371: Bindu: Start - Bug fix for the issue for DOB
        reName.test(LastName) &&
        reGoodDate.test(DOB)
        //FB 4371: Bindu: End - Bug fix for the issue for DOB
      ) {
        setNavigate(true);
      }
    } else {
      if (
        FirstName.length != 0 &&
        LastName.length != 0 &&
        //FB 4371: Bindu - Bug fix for the issue for DOB
        DOB != null &&
        Gender != 0
      ) {
        if (patType == "existing") {
          if (
            FirstName.length != 0 &&
            LastName.length != 0 &&
            Email.length != 0 &&
            Address.length != 0 &&
            ZipCode.length != 0 &&
            CellPhone.length != 0 &&
            City.length != 0 &&
            (enableReasonForAppt ? Comments.length != 0 : true) && //FB 9538
            statename != "" &&
            //FB 4371: Bindu - Bug fix for the issue for DOB
            DOB != null &&
            Gender != 0 &&
            DOB <= todaysDate &&
            CellPhone.length === 14 &&  //FB-4867
            ZipCode.length === 5 &&
            reEmail.test(Email) &&  //FB-4924
            reName.test(FirstName) &&
            reName.test(LastName)
          ) {
            setNavigate(true);
          }
        } //FB 8917 - Removed unused code
      }
    }
  };

  //FB 7801 - Begin
  const [sessionAppointment_n, setSessionAppointment_n] = React.useState("");
  const [sessionAppointment, setSessionAppointment] = React.useState("");
  const [sessionAppointmentDuration, setSessionAppointmentDuration] = React.useState("");
  const getSessionStorageValues = () => {
    const appt_n = sessionStorage.getItem("AppointmentType_N");
    const appt = sessionStorage.getItem("AppointmentType");
    const appt_duration = sessionStorage.getItem("Duration");
    setSessionAppointment_n(appt_n!);
    setSessionAppointment(appt!);
    setSessionAppointmentDuration(appt_duration!);
  }

  useEffect(() => {
    //FB 7719 Begin
    const validateBackButton = sessionStorage.getItem("BackFromCreditCardScreen");
    if (validateBackButton == "True") {
      var PatientDetails = sessionStorage.getItem("PatientDetails");
      if (PatientDetails !== null) {
        var patientDetailsArray = JSON.parse(PatientDetails);
        setFirstName(patientDetailsArray[0]);
        setLastName(patientDetailsArray[1]);
        setDateforDOBfield(patientDetailsArray[2]);
        setGender(Number(patientDetailsArray[3]));
        let dob = new Date(patientDetailsArray[2]);
        handleDOBChange(dob);
        setEmail(patientDetailsArray[4]);
        setCellPhone(patientDetailsArray[5]);
        setAddress(patientDetailsArray[6]);
        setCity(patientDetailsArray[7]);
        setStatename((patientDetailsArray[8]));
        setZipCode(patientDetailsArray[9]);
        setEmailPref(Number(patientDetailsArray[10]));
        setTextPref(Number(patientDetailsArray[11]));
        setComments(patientDetailsArray[12]);
        if (state.patient.patient_type == "existing") {
          SetdisplayVerfiedMessage("flex");
        }
      }
    }
    //FB 7719 End
    getSessionStorageValues();
    getadminsettingCCInfo(); //FB 7719 
    getadminsettingEnableReasonForAppt(); //FB 9538
  }, []);
  //FB 7801 - End

  useEffect(() => {
    navigationValidation();
  }, [
    FirstName,
    LastName,
    DOB,
    Gender,
    Email,
    Address,
    ZipCode,
    CellPhone,
    City,
    statename,
    Comments,
  ]); //FB 9538 included comments

  //FB 4371 BR    03/29/2021    validation for patient gender
  const handleGenderChange = (event: React.ChangeEvent<{ value: any }>) => {
    setGender(parseInt(event.target.value));
    if (event.target.value === "") {
      setGenderError(true);
      setGenderMessage("Select the State");
    } else {
      setGenderError(false);
      setGenderMessage("");
    }
  };

  //FB 4371 BR    03/29/2021    validation for patient state
  const handleStateChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setStatename(event.target.value as string);
    if (event.target.value === "") {
      setStatesError(true);
      setStateMessage("Select the State");
    } else {
      setStatesError(false);
      setStateMessage("");
    }
  };

  //FB 4574 DK - Modified the timer logic to expire after 10mins - Start
  React.useEffect(() => {
    if (seconds <= 600) {
      if (seconds === 60) {
        setMinutesLeft("9");
        setState({ ...snackbarState, open: true });
      }
      if (seconds === 120) {
        setMinutesLeft("8");
        setState({ ...snackbarState, open: true });
      }
      if (seconds === 180) {
        setMinutesLeft("7");
        setState({ ...snackbarState, open: true });
      }
      if (seconds === 240) {
        setMinutesLeft("6");
        setState({ ...snackbarState, open: true });
      }
      if (seconds === 300) {
        setMinutesLeft("5");
        setState({ ...snackbarState, open: true });
      }
      if (seconds === 360) {
        setMinutesLeft("4");
        setState({ ...snackbarState, open: true });
      }
      if (seconds === 420) {
        setMinutesLeft("3");
        setState({ ...snackbarState, open: true });
      }
      if (seconds === 480) {
        setMinutesLeft("2");
        setState({ ...snackbarState, open: true });
      }
      if (seconds === 540) {
        setMinutesLeft("1");
        setState({ ...snackbarState, open: true });
      }
      if (seconds === 600) {
        setMinutesLeft("0");
        setState({ ...snackbarState, open: true });
        SetBtnDisable(true);
        //alert("hi");
        remove_reg(state.slotDetails.id);
      }
    }
  }, [seconds]);
  //FB 4574 DK - Modified the timer logic to expire after 10mins - End

  React.useEffect(() => {
    const interval = setInterval(() => {
      //setCount(countRef.current + 1);
      setSeconds((seconds) => seconds + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    get_States(dispatch).then(() => {
      setStates(state.states);
    });
    if (patType == "new") {
      setCallCreatePatient(true);
      setDisplayvalue("initial");
      setDisplaymessage("none");
      setDisablebutton("initial");
      setVerifydisplay("none");
      setNavigation(true);
    } else {
      setCallCreatePatient(false);
      setDisplaymessage("none");
      setDisablebutton("none");
      setVerifydisplay("initial");
    }
  }, []);

  const loading = opens && state.states.length === 0;
  //FB 7719 Begin
  const [model, setModel] = useState(false);
  async function getCardname(PATIENT_N: any) {
    var data = await GetSavedCards(PATIENT_N);
    if (data && data.length > 0) {
      setModel(true);
    }
  }
  //FB 7719 End

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    if (active) {
      setStates(states);
    }

    return () => {
      active = false;
    };
  }, [loading, state.states.length]);

  //FB 7719 Removed Unused part of Code

  //FB 4371 BR    03/29/2021    validation for patient cell phone
  const handleCellPhoneChange = (event: any) => {
    const re = /^[0-9\b ()-]+$/;    //FB-4867
    if (event.target.value === "" || re.test(event.target.value)) {
      setCellPhone(normalizeInput(event.target.value));   //FB-4867

      setValidationObj({
        ...validationObj,
        cellPhoneError: true,
        cellPhoneMessage: "Enter the valid CellPhone",
      });
      setCellPhoneError(true);
      setCellPhoneMessage("Enter the valid CellPhone");
    }

    if (event.target.value != "") {
      setValidationObj({
        ...validationObj,
        cellPhoneError: false,
        cellPhoneMessage: "",
      });

      setCellPhoneError(false);
      setCellPhoneMessage("");
    }
  };

  //FB 4371 BR    03/29/2021    validation for patient zip code
  const handleZipCodeChange = (event: any) => {
    const re = /^[0-9\b]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      setZipCode(event.target.value);

      setValidationObj({
        ...validationObj,
        postalCodeError: true,
        postalCodeMessage: "Enter the valid Postal Code",
      });
    }
    if (event.target.value != "") {
      setValidationObj({
        ...validationObj,
        postalCodeError: false,
        postalCodeMessage: "",
      });
    }
  };

  //FB 4371 BR    03/29/2021    validation for patient address
  const handleAddressChange = (event: any) => {
    const re = /^[#.0-9a-zA-Z\s,-]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      setAddress(event.target.value);

      setValidationObj({
        ...validationObj,
        addressError: true,
        addressMessage: "Enter the valid Address",
      });

      setAddressError(true);
      setAddressMessage("Enter the valid Address");
    }
    if (event.target.value != "") {
      setValidationObj({
        ...validationObj,
        addressError: false,
        addressMessage: "",
      });

      setAddressError(false);
      setAddressMessage("");
    }
  };

  //FB 4371 BR    03/29/2021    validation for patient city
  const handleCityChange = (event: any) => {
    setCity(event.target.value);
    if (event.target.value === "") {
      setValidationObj({
        ...validationObj,
        cityError: true,
        cityMessage: "Enter the valid City",
      });

      setCityError(true);
      setCityMessage("Enter the valid City");
    }
    if (event.target.value != "") {
      setValidationObj({ ...validationObj, cityError: false, cityMessage: "" });
      setCityError(false);
      setCityMessage("");
    }
  };

  //FB 9538 start
  const handleCommentChange = (event: any) => {
    setComments(event.target.value);
    if (event.target.value === "") {
      setValidationObj({
        ...validationObj,
        commentError: true,
        commentMessage: "Enter the Reason for appointment booking",
      });
      setCommentError(true);
      setCommentMessage("Enter the Reason for appointment booking");
    }
    if (event.target.value != "") {
      setValidationObj({ ...validationObj, commentError: false, commentMessage: "" });
      setCommentError(false);
      setCommentMessage("");
    }
  };
  //FB 9538 end

  //FB 4371 BR    03/29/2021    validation for patient email
  const handleEmailChange = (event: any) => {
    setEmail(event.target.value);
    //FB 4924
    if (event.target.value === "" && reEmail.test(event.target.value)) {  //FB-4924
      setEmail(event.target.value);

      setValidationObj({
        ...validationObj,
        emailError: true,
        emailMessage: "Enter the valid email",
      });

      setEmailError(true);
      setEmailMessage("Enter the valid email");
    }
    if (event.target.value != "") {
      setValidationObj({
        ...validationObj,
        emailError: false,
        emailMessage: "",
      });

      setEmailError(false);
      setEmailMessage("");
    }
  };

  //FB 4371 BR    03/29/2021    validation for patient first name
  const handleFirstNameChange = (event: any) => {
    setFirstName(event.target.value);
    const re = /^(?=.{1,40}$)[a-zA-Z0-9 ]+(?:[-'\s][a-zA-Z0-9 ]+)*$/;
    if (event.target.value === "" && re.test(event.target.value)) {
      setFirstName(event.target.value);

      setValidationObj({
        ...validationObj,
        firstNameError: true,
        firstNameMessage: "Enter valid first name",
      });

      setfirstNameError(true);
      setfirstNameMessage("Enter valid first name");
    }
    if (event.target.value != "") {
      setValidationObj({
        ...validationObj,
        firstNameError: false,
        firstNameMessage: "",
      });

      setfirstNameError(false);
      setfirstNameMessage("");
    }
  };

  //FB 4371 BR    03/29/2021    validation for patient last name
  const handleLastNameChange = (event: any) => {
    setLastName(event.target.value);
    const re = /^(?=.{1,40}$)[a-zA-Z0-9 ]+(?:[-'\s][a-zA-Z0-9 ]+)*$/;
    if (event.target.value === "" && re.test(event.target.value)) {
      setLastName(event.target.value);

      setValidationObj({
        ...validationObj,
        lastNameError: true,
        lastNameMessage: "Enter valid last name",
      });

      setlastNameError(true);
      setlastNameMessage("Enter valid last name");
    }
    if (event.target.value != "") {
      setValidationObj({
        ...validationObj,
        lastNameError: false,
        lastNameMessage: "",
      });

      setlastNameError(false);
      setlastNameMessage("");
    }
  };

  //FB 4371 BR    03/29/2021    validation for patient DOB
  //FB 4371: Bindu: Start - Bug fix for the issue for DOB
  const handleDOBChange = (date: any) => {
    if (date != null && date != "Invalid Date") {
      setDateforDOBfield(date);		//FB 4499 DK - Save the selected date
      setDOB(format(date, "yyyy-MM-dd"));
      if (
        format(date, "yyyy-MM-dd") < "1800-01-01" &&
        format(date, "yyyy-MM-dd") > "9999-01-01"
      ) {
        alert(format(date, "yyyy-MM-dd"));
      }
      if (date == null) {
        setDOBError(true);
        setDOBMessage("Enter valid Date of Birth");
      }
      if (date != null) {
        setDOBError(false);
        setDOBMessage("");
      }
    }
    else {
      if (date == "Invalid Date") {
        setDOBError(true);
        setDOBMessage("Enter valid Date of Birth");
      }
    }
  };
  //FB 4371: Bindu: End - Bug fix for the issue for DOB
  const handleClose = () => {
    remove_reg(state.slotDetails.id);
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Close");
    //FB 4960 End
    //FB 4735 DK - Added condition to redirect to provider flow 
    if (state.defaultprovider.id > 0) {
      let apptType = state.appointmentdetails.appointmenttype === "inoffice" ? "/1/" : "/2/";
      window.location.href = apptType + state.defaultprovider.id;
    }
    else {
      history.push("");
    }
    setOpenDialog(false);
  };

  //FB 4533 BR- GA to Patient Engagement
  const GAtracking = () => {
    ReactGA.event({
      category: 'Button',
      action: 'Appointment Booking'
    })
  }

  //FB 4780 BR-Start In PE, Getting Email/Cell for Existing Patients  
  const handlePatientEmailChange = (event: any) => {
    //FB 4867 - Changed validation
    setPatientEmail(event.target.value);
    //FB 4924
    if (event.target.value === "" && reEmail.test(event.target.value)) {  //FB-4924
      setPatientEmail(event.target.value);

      setValidationObj({
        ...validationObj,
        emailError: true,
        emailMessage: "Enter the valid email",
      });

      setEmailError(true);
      setEmailMessage("Enter the valid email");
    }
    if (event.target.value != "") {
      setValidationObj({
        ...validationObj,
        emailError: false,
        emailMessage: "",
      });

      setEmailError(false);
      setEmailMessage("");
    }
  };

  const handlePatientCellPhoneChange = (event: any) => {
    const re = /^[0-9\b ()-]+$/;    //FB-4867
    if (event.target.value === "" || re.test(event.target.value)) {
      setPatientCellPhone(normalizeInput(event.target.value));     //FB-4867

      setValidationObj({
        ...validationObj,
        cellPhoneError: true,
        cellPhoneMessage: "Enter the valid CellPhone",
      });
      setCellPhoneError(true);
      setCellPhoneMessage("Enter the valid CellPhone");
    }

    if (event.target.value != "") {
      setValidationObj({
        ...validationObj,
        cellPhoneError: false,
        cellPhoneMessage: "",
      });

      setCellPhoneError(false);
      setCellPhoneMessage("");
    }
  };

  const updateEmailCellPhoneButton = async () => {
    //FB 4924
    if (patientEmail == null) {
      setValidationObj({
        ...validationObj,
        emailError: true,
        emailMessage: "Enter  valid email",
      });
      setEmailError(true);
      setEmailMessage("Enter valid email");
    }
    if (patientEmail != null) {
      if (patientEmail.length == 0) {
        setValidationObj({
          ...validationObj,
          emailError: true,
          emailMessage: "Enter  valid email",
        });
        setEmailError(true);
        setEmailMessage("Enter valid email");
      }

      if (!reEmail.test(patientEmail)) {  //FB-4924
        setValidationObj({
          ...validationObj,
          emailError: true,
          emailMessage: "Enter valid email",
        });
        setEmailError(true);
        setEmailMessage("Enter valid email");
      }
    }
    if (patientCellPhone == null) {
      setValidationObj({
        ...validationObj,
        cellPhoneError: true,
        cellPhoneMessage: "Enter valid Cell Phone",
      });
      setCellPhoneError(true);
      setCellPhoneMessage("Enter valid Cell Phone");
    }
    if (patientCellPhone != null) {
      if (patientCellPhone.length == 0 || patientCellPhone.length != 14) {   //FB 4867 - Increased the maximum length
        setValidationObj({
          ...validationObj,
          cellPhoneError: true,
          cellPhoneMessage: "Enter valid Cell Phone",
        });
        setCellPhoneError(true);
        setCellPhoneMessage("Enter valid Cell Phone");
      }
    }
    if (reEmail.test(patientEmail) && patientEmail.length != 0 && patientCellPhone.length != 0 && patientCellPhone.length == 14) {  //FB 4867 - Increased the maximum length , FB-4924
      const patId = await SearchPatient(patientObj);
      const response = await UpdateEmailCellPhone(patId[0].Id, patientEmail, patientCellPhone);
      setOpenUpdateEmailDialog(false);
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Clicked on Update - Update patient email and cellphone dialog");
      //FB 4960 End
    }
  }

  const handleDialogClose = () => {
    //FB 4924
    if (patientEmail == null) {
      setValidationObj({
        ...validationObj,
        emailError: true,
        emailMessage: "Enter  valid email",
      });
      setEmailError(true);
      setEmailMessage("Enter valid email");
    }
    if (patientEmail != null) {
      if (patientEmail.length == 0) {
        setValidationObj({
          ...validationObj,
          emailError: true,
          emailMessage: "Enter  valid email",
        });
        setEmailError(true);
        setEmailMessage("Enter valid email");
      }

      if (!reEmail.test(patientEmail)) {  //FB-4924
        setValidationObj({
          ...validationObj,
          emailError: true,
          emailMessage: "Enter valid email",
        });
        setEmailError(true);
        setEmailMessage("Enter valid email");
      }
    }
    if (patientCellPhone == null) {
      setValidationObj({
        ...validationObj,
        cellPhoneError: true,
        cellPhoneMessage: "Enter valid Cell Phone",
      });
      setCellPhoneError(true);
      setCellPhoneMessage("Enter valid Cell Phone");
    }
    if (patientCellPhone != null) {
      if (patientCellPhone.length == 0 || patientCellPhone.length != 14) {   //FB 4867 - Increased the maximum length
        setValidationObj({
          ...validationObj,
          cellPhoneError: true,
          cellPhoneMessage: "Enter valid Cell Phone",
        });
        setCellPhoneError(true);
        setCellPhoneMessage("Enter valid Cell Phone");
      }
    }
    if (reEmail.test(patientEmail) && patientEmail.length != 0 && patientCellPhone.length != 0 && patientCellPhone.length == 14) {    //FB 4867 - Increased the maximum length , //FB-4924
      setOpenUpdateEmailDialog(false);
    }
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Close");
    //FB 4960 End
  };
  //FB 4780 BR-End In PE, Getting Email/Cell for Existing Patients


  //FB 4371 BR    03/29/2021    Dialog close button funcationality
  //FB 4556 DK - Implement client side error handling on PE
  const handleCloseDialog = async () => {
    setOpenValidationDialog(false);
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Close - exiting patient verification successful dialog");
    //FB 4960 End
    appObj.PATIENT_N = patn;
    var date = new Date(appObj.APPOINTMENT_DATE);
    var x = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - x);
    // if (date.getTimezoneOffset() === 240) {
    //   date.setMinutes(date.getMinutes() - 240);
    // }
    appObj.APPOINTMENT_DATE = date;
    appObj.APPOINTMENT_CHECKIN_TIME = date;
    appObj.APPOINTMENT_CREATION_DATE = todaysDate;
    //FB 7456 Begin
    appObj.APPOINTMENT_TYPE_NAME === "New Patient - Inoffice Appointment" ?
      appObj.APPOINTMENT_TYPE_NAME = "Existing Patient - Inoffice Appointment" :
      appObj.APPOINTMENT_TYPE_NAME = "Existing Patient - " + globalsettings.digitalApptType + " Appointment";
    // appObj.APPOINTMENT_TYPE_NAME = "Existing Patient - Inoffice Appointment"; // commented old code
    //FB 7456 End
    //FB 4556 DK - Implement client side error handling on PE - Start
    //FB 6752
    let comm_pref = "";
    if (emailPref === 1 && textPref === 1) {
      comm_pref = "E-mail & Text";
    } else if (textPref === 1) {
      comm_pref = "Text";
    } else if (emailPref === 1) {
      comm_pref = "E-mail"
    }
    //FB 7801 - Begin
    if (Number(sessionAppointmentDuration) > 0) {
      appObj.DURATION = Number(sessionAppointmentDuration);
      appObj.APPOINTMENT_TYPE_NAME = sessionAppointment;
      appObj.APPOINTMENT_TYPE_OF_WORK = sessionAppointment;
    }
    //FB 7801 - End
    await UpdatePatientCommunicationPreference(appObj.PATIENT_N, comm_pref);
    //FB 7719 - Begin
    let result = 0;
    if (requireCC == 1) {
      result = 0;
      sessionStorage.setItem("appObj", JSON.stringify(appObj));
      sessionStorage.setItem("patObj", JSON.stringify(patientObj));
      var patientDetailsArray = [FirstName, LastName, dateforDOBfield, Gender, Email, CellPhone, Address, City, statename, ZipCode, emailPref, textPref, Comments];
      var patientDetailsString = JSON.stringify(patientDetailsArray);
      sessionStorage.setItem("PatientDetails", patientDetailsString);
      if (model) {
        result = await create_appointment(appObj);
        state.patient.name = FirstName;
        state.patient.appointment_n = result;   //FB 4867 DK - Added appointment_n to state
        history.push("/confirmationPage", state);
      }
      else {
        history.push("/addCC", state);
      }
    }
    else {
      result = await create_appointment(appObj);
      //FB 8917
      state.patient.name = FirstName;
      state.patient.appointment_n = result;
      history.push("/confirmationPage", state);
    }
    //FB 7719 - End
    if (navigate == true) {
      //FB 4556 DK - Implement client side error handling on PE - End
      //FB 4533 BR-Start GA to Patient Engagement
      GAtracking();
      //FB 4533 BR-End GA to Patient Engagement
    }
  };

  useEffect(() => {
    if (minutesLeft < 1) {
      setDisableFields(true);
      //FB 4780 BR - closing the update email and cellphone dialog on session expiry
      setOpenUpdateEmailDialog(false);
    }
  }, [minutesLeft]);

  //FB 6752 - Start
  useEffect(() => {
    if (displayVerfiedMessage != "none") {
      setShowPref(true);
    }
  }, [displayVerfiedMessage]);

  useEffect(() => {
    if (callCreatePatient) {
      setShowPref(true);
    }
  }, [callCreatePatient]);

  useEffect(() => {
    if (patientPref.includes("mail") && (patientPref.includes("text") || patientPref.includes("phone"))) {
      setEmailPref(1);
      setTextPref(1);
    }
    else if (patientPref.includes("mail")) {
      setEmailPref(1);
    } else if (patientPref.includes("text") || patientPref.includes("phone")) {
      setTextPref(1);
    }
  }, [patientPref]);
  //FB 6752 - End

  const DialogTitle = withStyles(styless)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography style={{ fontSize: "14px" }}>{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });


  //FB 4371 BR    03/29/2021    book appointment button functionality
  const bookApptButtonClick = async () => {
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Book Appointment - Demographics");
    //FB 4960 End
    //FB 4924
    //FB 4371: Bindu - Bug fix for the issue for DOB
    var reGoodDate = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
    if (
      FirstName.length != 0 &&
      firstNameMessage.length == 0 &&
      LastName.length != 0 &&
      lastNameMessage.length == 0 &&
      //FB 4371: Bindu - Bug fix for the issue for DOB
      DOB != null &&
      Gender != 0 &&
      genderMessage.length == 0 &&
      Address.length != 0 &&
      AddressMessage.length == 0 &&
      City.length != 0 &&
      CityMessage.length == 0 &&
      (enableReasonForAppt ? Comments.length != 0 : true) && //FB 9538
      (enableReasonForAppt ? CommentMessage.length == 0 : true) && //FB 9538
      statename.length != 0 &&
      stateMessage.length == 0 &&
      ZipCode.length != 0 &&
      reEmail.test(Email) &&  //FB-4924
      CellPhone.length == 14 &&   //FB-4867
      //FB 4371: Bindu:Start - Bug fix for the issue for DOB
      statename.length != 1 &&
      reGoodDate.test(DOB)
      //FB 4371: Bindu:End - Bug fix for the issue for DOB
    ) {
      SetBtnDisable(true);
    }

    //FB 8917
    if (statename == "" || statename.length == 1) {
      setStatesError(true);
      setStateMessage("Select the state");
    }
    if (Gender == 0) {
      setGenderError(true);
      setGenderMessage("Select the gender");
    }
    //FB 4371: Bindu:Start - Bug fix for the DOB
    if (DOB == null) {
      setDOBError(true);
      setDOBMessage("Enter valid Date of Birth");
    }
    var reGoodDate = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
    if (!reGoodDate.test(DOB)) {
      setDOBError(true);
      setDOBMessage("Enter valid Date of Birth");
    }
    //FB 4371: Bindu:End - Bug fix for the issue for DOB
    if (Email.length == 0) {
      setValidationObj({
        ...validationObj,
        emailError: true,
        emailMessage: "Enter the valid email",
      });
      setEmailError(true);
      setEmailMessage("Enter the valid email");
    }

    //FB 4924
    if (!reEmail.test(Email)) { //FB-4924
      setValidationObj({
        ...validationObj,
        emailError: true,
        emailMessage: "Enter the valid email",
      });
      setEmailError(true);
      setEmailMessage("Enter the valid email");
    }

    const reName = /^(?=.{1,40}$)[a-zA-Z0-9 ]+(?:[-'\s][a-zA-Z0-9 ]+)*$/;
    if (!reName.test(FirstName)) {
      setValidationObj({
        ...validationObj,
        firstNameError: true,
        firstNameMessage: "Enter valid first name",
      });
      setfirstNameError(true);
      setfirstNameMessage("Enter valid first name");
    }
    if (!reName.test(LastName)) {
      setValidationObj({
        ...validationObj,
        lastNameError: true,
        lastNameMessage: "Enter valid last name",
      });
      setlastNameError(true);
      setlastNameMessage("Enter valid last name");
    }

    if (CellPhone.length == 0 || CellPhone.length != 14) {    //FB-4867
      setValidationObj({
        ...validationObj,
        cellPhoneError: true,
        cellPhoneMessage: "Enter the valid CellPhone",
      });
      setCellPhoneError(true);
      setCellPhoneMessage("Enter the valid CellPhone");
    }
    if (Address.length == 0) {
      setValidationObj({
        ...validationObj,
        addressError: true,
        addressMessage: "Enter the valid Address",
      });
      setAddressError(true);
      setAddressMessage("Enter the valid Address");
    }
    if (City.length == 0) {
      setValidationObj({
        ...validationObj,
        cityError: true,
        cityMessage: "Enter the valid City",
      });
      setCityError(true);
      setCityMessage("Enter the valid City");
    }
	//FB 9538 start
    if (Comments.length == 0) {
      setValidationObj({
        ...validationObj,
        commentError: true,
        commentMessage: "Enter the Reason",
      });
      setCommentError(true);
      setCommentMessage("Enter the Reason");
    }
	//FB 9538 end
    if (ZipCode.length == 0 || ZipCode.length != 5) {
      setValidationObj({
        ...validationObj,
        postalCodeError: true,
        postalCodeMessage: "Enter the valid Postal Code",
      });
    }

    //FB 8917 - Removed unused code

    if (patType == "new") {
      //FB 4924
      const reName = /^(?=.{1,40}$)[a-zA-Z0-9 ]+(?:[-'\s][a-zA-Z0-9 ]+)*$/;
      if (
        FirstName.length != 0 &&
        LastName.length != 0 &&
        Email.length != 0 &&
        Address.length != 0 &&
        ZipCode.length != 0 &&
        CellPhone.length != 0 &&
        City.length != 0 &&
        (enableReasonForAppt ? Comments.length != 0 : true) &&  //FB 9538
        statename != "" &&
        //FB 4371: Bindu - Bug fix for the issue for DOB
        DOB != null &&
        Gender != 0 &&
        DOB <= todaysDate &&
        CellPhone.length === 14 &&    //FB-4867
        ZipCode.length === 5 &&
        reEmail.test(Email) &&  //FB-4924
        reName.test(FirstName) &&
        reName.test(LastName) &&
        //FB 4371: Bindu:Start - Bug fix for the issue for DOB
        statename.length != 1 &&
        reGoodDate.test(DOB)
        //FB 4371: Bindu:End - Bug fix for the issue for DOB
      ) {
        //FB 4371: Bindu - Bug fix for the issue which was creating 2 appointments on button click
        SetBtnDisable(true);
        const data = await AppointmentCount(
          state.slotDetails.slotDate,
          FirstName,
          LastName,
          DOB,
          Gender
        );
        setCount(data);
        if (data >= 1) {
          setOpenDialog(true);
        } else {
          setOpenDialog(false);
          if (callCreatePatient == true && navigate == true) {
            var date = new Date(appObj.APPOINTMENT_DATE);
            const ptData = await SearchPatient(patientObj);
            //FB 8917 - Removed unused code
            appObj.APPOINTMENT_DATE = date;
            appObj.APPOINTMENT_CHECKIN_TIME = date;
            appObj.PATIENT_N = returnValue;
            //FB 8917 - Removed unused code
            //FB 7801 - Begin
            if (Number(sessionAppointmentDuration) > 0) {
              appObj.DURATION = Number(sessionAppointmentDuration);
              appObj.APPOINTMENT_TYPE_NAME = sessionAppointment;
              appObj.APPOINTMENT_TYPE_OF_WORK = sessionAppointment;
            }
            //FB 7801 - End
            appObj.APPOINTMENT_CREATION_DATE = todaysDate;
            if (ptData.length != 0 || ptData[0] != undefined) {
              appObj.PATIENT_N =
                ptData[0].PE_PATIENT_N > 0
                  ? ptData[0].PE_PATIENT_N
                  : ptData[0].Id;
              setPatn(ptData[0].Id);
              //FB 4959 MS BEGIN
              const ptTypeData = await GetPatientType(ptData[0].Id);
              await UpdateEmailCellPhone(ptData[0].Id, Email, CellPhone); //FB 6006
              if (ptTypeData == 1)
                state.patient.patient_type = "existing";
              //FB 4959 MS END
              appObj.APPOINTMENT_CREATION_DATE = todaysDate;
              //alert("We found this user in our records! We will proceed with the existing details.");
              setOpenValidationDialog(true);
              await getCardname(ptData[0].Id);//FB 7719
              return;
            } else {
              if (patientObj.PATIENT_FIRST_NAME !== "") {
                patientObj.PATIENT_FIRST_NAME =
                  patientObj.PATIENT_FIRST_NAME.charAt(0).toUpperCase() +
                  patientObj.PATIENT_FIRST_NAME.slice(1);
              }
              //FB 6752
              let comm_pref = "";
              if (emailPref === 1 && textPref === 1) {
                comm_pref = "E-mail & Text";
              } else if (textPref === 1) {
                comm_pref = "Text";
              } else if (emailPref === 1) {
                comm_pref = "E-mail"
              }
              patientObj.PATIENT_COMMUNICATION_PREFERENCE = comm_pref;
              //FB 7801 - Begin
              if (Number(sessionAppointmentDuration) > 0) {
                appObj.DURATION = Number(sessionAppointmentDuration);
                appObj.APPOINTMENT_TYPE_NAME = sessionAppointment;
                appObj.APPOINTMENT_TYPE_OF_WORK = sessionAppointment;
              }
              //FB 7801 - End
              //FB 4556 DK - Implement client side error handling on PE - Start
              //FB 7719 Begin
              let result = 0;
              if (requireCC) {
                result = 0;
                sessionStorage.setItem("appObj", JSON.stringify(appObj));
                sessionStorage.setItem("patObj", JSON.stringify(patientObj));
                var patientDetailsArray = [FirstName, LastName, dateforDOBfield, Gender, Email, CellPhone, Address, City, statename, ZipCode, emailPref, textPref, Comments];

                // Convert the array to a JSON string
                var patientDetailsString = JSON.stringify(patientDetailsArray);

                // Store the JSON string in sessionStorage
                sessionStorage.setItem("PatientDetails", patientDetailsString);
              }
              else {
                result = await create_patient(patientObj, appObj, state.slotDetails.id);
              }
              //FB 7719 End
              //FB 4960 Start
              var selectedGender
              if (Gender == 1) {
                selectedGender = 'Male';
              }
              else if (Gender == 2) {
                selectedGender = 'Female';
              }
              else if (Gender == 3) {
                selectedGender = 'Unknown';
              }
              InsertPELogs(globalsettings.clientIp, "The patients details are " + FirstName + ", " + LastName + ", " + DOB + ", " + selectedGender + ", " + Email + ", " + CellPhone + ", " + Address + ", " + City + ", " + statename + ", " + ZipCode);
              //FB 4960 End
              if (result != 0 && navigate == true) {
                state.patient.name = FirstName;
                state.patient.appointment_n = result;   //FB 4867 DK - Added appointment_n to state

                history.push("/confirmationPage", state);
              }
              //FB 7719 Begin
              else {
                if (result == 0) {
                  if (requireCC == 1) {
                    result = 0;
                    sessionStorage.setItem("appObj", JSON.stringify(appObj));
                    sessionStorage.setItem("patObj", JSON.stringify(patientObj));
                    var patientDetailsArray = [FirstName, LastName, dateforDOBfield, Gender, Email, CellPhone, Address, City, statename, ZipCode, emailPref, textPref, Comments];
                    var patientDetailsString = JSON.stringify(patientDetailsArray);
                    sessionStorage.setItem("PatientDetails", patientDetailsString);
                    if (model) {
                      result = await create_appointment(appObj);
                      state.patient.name = FirstName;
                      state.patient.appointment_n = result;   //FB 4867 DK - Added appointment_n to state
                      history.push("/confirmationPage", state);
                    }
                    else {
                      history.push("/addCC", state);
                    }
                  }
                  else {
                    result = await create_appointment(appObj);
                    //FB 8917
                    state.patient.name = FirstName;
                    state.patient.appointment_n = result;
                    history.push("/confirmationPage", state);
                  }
                }
              }
              //FB 7719 End
              //FB 4556 DK - Implement client side error handling on PE - End
            }
          }
          if (navigate == true) {
            //FB 4533 BR-Start GA to Patient Engagement
            GAtracking();
            //FB 4533 BR-End GA to Patient Engagement
          }
          //FB 8917 - Removed unused code
        }
      }
    } else {
      //FB 4371: Bindu - Bug fix for the issue for DOB
      var reGoodDate = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
      //FB 7330 Begin-Removed extra conditions inside IF
      if (
        FirstName.length != 0 &&
        LastName.length != 0 &&
        //FB 4371: Bindu - Bug fix for the issue for DOB
        DOB != null &&
        Gender != 0 &&
        (enableReasonForAppt ? Comments.length != 0 : true) && //FB 9538
        DOB <= todaysDate &&
        reGoodDate.test(DOB)
        //FB 4371: Bindu:End - Bug fix for the issue for DOB
        //FB 7269 End
        //FB 7330 End
      ) {
        //FB 8917 - Removed unused code
        //FB 4371: Bindu - Bug fix for the issue which was creating 2 appointments on button click
        //FB 7330 Begin
        const data = await AppointmentCount(
          state.slotDetails.slotDate,
          FirstName,
          LastName,
          DOB,
          Gender
        );
        setCount(data);
        if (data >= 1) {
          setOpenDialog(true);
        } else {
          setOpenDialog(false);
          if (callCreatePatient == true && navigate == true) {
            if (FirstName.length != 0 &&
              LastName.length != 0 &&
              Email.length != 0 &&
              Address.length != 0 &&
              ZipCode.length != 0 &&
              CellPhone.length != 0 &&
              City.length != 0 &&
              (enableReasonForAppt ? Comments.length != 0 : true) && //FB 9538
              statename != "" &&
              //FB 4371: Bindu - Bug fix for the issue for DOB
              DOB != null &&
              Gender != 0 &&
              DOB <= todaysDate &&
              CellPhone.length === 14 &&    //FB-4867
              ZipCode.length === 5 &&
              reEmail.test(Email) &&  //FB-4924
              reName.test(FirstName) &&
              reName.test(LastName) &&
              //FB 4371: Bindu:Start - Bug fix for the issue for DOB
              statename.length != 1 &&
              reGoodDate.test(DOB)) {
              SetBtnDisable(true);
            }
            //FB 7330 End
            var date = new Date(appObj.APPOINTMENT_DATE);
            //FB 8917 - Removed unused code
            appObj.APPOINTMENT_DATE = date;
            appObj.APPOINTMENT_CHECKIN_TIME = date;
            appObj.PATIENT_N = returnValue;
            appObj.APPOINTMENT_CREATION_DATE = todaysDate;
            if (patientObj.PATIENT_FIRST_NAME !== "") {
              patientObj.PATIENT_FIRST_NAME =
                patientObj.PATIENT_FIRST_NAME.charAt(0).toUpperCase() +
                patientObj.PATIENT_FIRST_NAME.slice(1);
            }
            //FB 4680 BR - PE - Existing patient workflow issues
            //FB 7456 Begin
            // appObj.APPOINTMENT_TYPE_NAME = "New Patient - Inoffice Appointment"; //Commented old code
            appObj.APPOINTMENT_TYPE_NAME === "Existing Patient - Inoffice Appointment" ?
              appObj.APPOINTMENT_TYPE_NAME = "New Patient - Inoffice Appointment" :
              appObj.APPOINTMENT_TYPE_NAME = "New Patient - " + globalsettings.digitalApptType + " Appointment";
            //FB 7456 End
            //FB 6752
            let comm_pref = "";
            if (emailPref === 1 && textPref === 1) {
              comm_pref = "E-mail & Text";
            } else if (textPref === 1) {
              comm_pref = "Text";
            } else if (emailPref === 1) {
              comm_pref = "E-mail"
            }
            //FB 7801 - Begin
            if (Number(sessionAppointmentDuration) > 0) {
              appObj.DURATION = Number(sessionAppointmentDuration);
              appObj.APPOINTMENT_TYPE_NAME = sessionAppointment;
              appObj.APPOINTMENT_TYPE_OF_WORK = sessionAppointment;
            }
            //FB 7801 - End
            patientObj.PATIENT_COMMUNICATION_PREFERENCE = comm_pref;
            //FB 4556 DK - Implement client side error handling on PE - Start
            //FB 7719 Begin
            let result = 0;
            if (requireCC == 1) {
              result = 0;
              sessionStorage.setItem("appObj", JSON.stringify(appObj));
              sessionStorage.setItem("patObj", JSON.stringify(patientObj));
              var patientDetailsArray = [FirstName, LastName, dateforDOBfield, Gender, Email, CellPhone, Address, City, statename, ZipCode, emailPref, textPref, Comments];
              var patientDetailsString = JSON.stringify(patientDetailsArray);
              sessionStorage.setItem("PatientDetails", patientDetailsString);
              if (model) {
                result = await create_appointment(appObj);
                state.patient.name = FirstName;
                state.patient.appointment_n = result;   //FB 4867 DK - Added appointment_n to state
                history.push("/confirmationPage", state);
              }
              else {
                history.push("/addCC", state);
              }
            }
            else {
              result = await create_appointment(appObj);
              //FB 8917
              state.patient.name = FirstName;
              state.patient.appointment_n = result;
              history.push("/confirmationPage", state);
            }
            //FB 7719 End
          }

          if (navigate == true) {
            GAtracking();   //FB 4533 BR - GA to Patient Engagement
          }
          if (callCreatePatient == false) {
            var date = new Date(appObj.APPOINTMENT_DATE);
            var x = date.getTimezoneOffset();
            date.setMinutes(date.getMinutes() - x);
            //FB 8917 - Removed unused code
            appObj.APPOINTMENT_DATE = date;
            appObj.APPOINTMENT_CHECKIN_TIME = date;
            appObj.PATIENT_N = returnValue;
            appObj.APPOINTMENT_CREATION_DATE = todaysDate;
            //FB 7801 - Begin
            if (Number(sessionAppointmentDuration) > 0) {
              appObj.DURATION = Number(sessionAppointmentDuration);
              appObj.APPOINTMENT_TYPE_NAME = sessionAppointment;
              appObj.APPOINTMENT_TYPE_OF_WORK = sessionAppointment;
            }
            //FB 7801 - End
            //FB 4556 DK - Implement client side error handling on PE - Start
            //FB 4578 DK - Removed syntax to avoid appointment booking twice
            //FB 4867 DK - sending appointment_n to state
            //FB 6752
            let comm_pref = "";
            if (emailPref === 1 && textPref === 1) {
              comm_pref = "E-mail & Text";
            } else if (textPref === 1) {
              comm_pref = "Text";
            } else if (emailPref === 1) {
              comm_pref = "E-mail"
            }
            await UpdatePatientCommunicationPreference(appObj.PATIENT_N, comm_pref);
            //FB 7719 Begin
            let result = 0;
            if (requireCC == 1) {
              result = 0;
              sessionStorage.setItem("appObj", JSON.stringify(appObj));
              sessionStorage.setItem("patObj", JSON.stringify(patientObj));
              var patientDetailsArray = [FirstName, LastName, dateforDOBfield, Gender, Email, CellPhone, Address, City, statename, ZipCode, emailPref, textPref, Comments];
              var patientDetailsString = JSON.stringify(patientDetailsArray);
              sessionStorage.setItem("PatientDetails", patientDetailsString);
              if (model) {
                result = await create_appointment(appObj);
                state.patient.name = FirstName;
                state.patient.appointment_n = result;   //FB 4867 DK - Added appointment_n to state
                history.push("/confirmationPage", state);
              }
              else {
                history.push("/addCC", state);
              }
            }
            else {
              result = await create_appointment(appObj);
              //FB 8917
              state.patient.name = FirstName;
              state.patient.appointment_n = result;
              history.push("/confirmationPage", state);
            }
            //FB 7719 End
            //FB 4556 DK - Implement client side error handling on PE - End
            //FB 4533 BR-Start GA to Patient Engagement
            GAtracking();
            //FB 4533 BR-End GA to Patient Engagement
          }
        }
      }
    }
  };

  const DialogActions = withStyles((theme: Theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);

  //FB 4371 BR    03/29/2021    validate button functinality
  const buttonclick = async () => {
    const reName = /^(?=.{1,40}$)[a-zA-Z0-9 ]+(?:[-'\s][a-zA-Z0-9 ]+)*$/;
    if (!reName.test(FirstName)) {
      setValidationObj({
        ...validationObj,
        firstNameError: true,
        firstNameMessage: "Enter valid first name",
      });
      setfirstNameError(true);
      setfirstNameMessage("Enter valid first name");
    }
    if (!reName.test(LastName)) {
      setValidationObj({
        ...validationObj,
        lastNameError: true,
        lastNameMessage: "Enter valid last name",
      });
      setlastNameError(true);
      setlastNameMessage("Enter valid last name");
    }
    //FB 4371: Bindu:Start - Bug fix for the DOB
    if (DOB == null) {
      setDOBError(true);
      setDOBMessage("Enter valid Date of Birth");
    }
    var reGoodDate = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
    if (!reGoodDate.test(DOB)) {
      setDOBError(true);
      setDOBMessage("Enter valid Date of Birth");
    }
    //FB 4371: Bindu:End - Bug fix for the issue for DOB

    if (
      FirstName.length != 0 &&
      LastName.length != 0 &&
      //FB 4371: Bindu - Bug fix for the issue for DOB
      DOB != null &&
      Gender != 0
    ) {
      const data = await SearchPatient(patientObj);
      if (data.length == 0 || data[0] == undefined) {
        setCallCreatePatient(true);
        setnavigateWhenNotFound(true);    //FB 8917
        setNavigate(false);
        setVerifydisplay("none");
        setDisplayvalue("initial");
        setDisplaymessage("flex");
        setDisablebutton("initial");
        state.appointmentdetails.patientType = "new";   //FB 8917
        patType = "new";    //FB 8917
      } else {
        //FB 4959 MS BEGIN
        const ptTypeData = await GetPatientType(data[0].Id);
        if (ptTypeData == 1)
          state.patient.patient_type = "existing";
        //FB 4959 END  
        setReturnvalue(
          data[0].PE_PATIENT_N > 0 ? data[0].PE_PATIENT_N : data[0].Id
        );
        await getCardname(data[0].Id); //FB 7719
        //FB 4780 BR:Start In PE, Getting Email/Cell for Existing Patients
        const patientDetails = await FetchEmailCellPhone(data[0].Id);
        setPatientEmail(patientDetails[0].email);

        //FB 4867 - Formatting the phone number - Start
        var cleaned = ('' + patientDetails[0].cellPhone).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        var phone = "";
        if (match) {
          phone = '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        setPatientCellPhone(phone);
        //FB 4867 - Formatting the phone number - End

        //FB 4780 BR:End In PE, Getting Email/Cell for Existing Patients
        setCallCreatePatient(false);
        setVerifydisplay("none");
        setNavigation(true);
        setDisplaymessage("none");
        setDisplayvalue("none");
        SetdisplayVerfiedMessage("flex");
        setDisableFields(true);
        setDisablebutton("initial");
        //FB 4780 BR In PE, Getting Email/Cell for Existing Patients
        setOpenUpdateEmailDialog(true);
        setPatientPref(data[0].PATIENT_COMMUNICATION_PREFERENCE.toLowerCase()); //FB 6752
      }
    } else {
      if (Gender == 0) {
        setGenderError(true);
        setGenderMessage("Select the gender");
      }
    }
  };

  //FB 4371 BR    03/29/2021    patient details object
  const patientObj = {
    PATIENT_FIRST_NAME: FirstName,
    PATIENT_LAST_NAME: LastName,
    PATIENT_BIRTH_DAY: DOB,
    GENDER_N: Gender,
    PATIENT_ADDRESS: Address,
    PATIENT_CITY_STATE_ZIP: City + ', ' + statename + ' ' + ZipCode,   //FB 4816 //FB 7719
    PATIENT_CELL_PHONE: CellPhone,
    PATIENT_EMAIL: Email,
    PATIENT_COMMENTS: null,
    PATIENT_INSURANCE_CARRIER:
      state.appointmentdetails.insurance.name === "OTHER"
        ? ""
        : state.appointmentdetails.insurance.name,
    PATIENT_INSURANCE_PLAN_NAME: state.appointmentdetails.insurance.planName,
    PATIENT_COMMUNICATION_PREFERENCE: ""  //FB 6752
  };

  //FB 10954
  //FB 4371 BR    03/29/2021    appointment details object
  const appObj = {
    APPOINTMENT_EXTERNAL_ID: "",
    PATIENT_N: 0,
    EMPLOYEE_N: state.slotDetails.employeeId,
    APPOINTMENT_DATE: state.slotDetails.slotDate,
    APPOINTMENT_CHECKIN_TIME: state.slotDetails.slotDate,
    APPOINTMENT_TYPE_OF_WORK: "",
    APPOINTMENT_IS_ACTIVE: true,
    APPOINTMENT_TYPE_NAME:
      state.appointmentdetails.appointmenttype === "inoffice"
        ? state.appointmentdetails.patientType === "new"
          ? "New Patient - Inoffice Appointment"
          : "Existing Patient - Inoffice Appointment"
        : state.appointmentdetails.patientType === "new"
          ? "New Patient - " + globalsettings.digitalApptType + " Appointment"
          : "Existing Patient - " +
          globalsettings.digitalApptType +
          " Appointment",
    DURATION: state.appointmentdetails.duration, //FB 4638 reading value from API
    CANCELLATION_REASON: "",
    COMMENT: Comments,
    COLUMN_NUMBER: 0,
    APPOINTMENT_EXTERNAL_ID_TEXT: "",
    FACILITY_N: state.slotDetails.facilityId,
    Last_Text_Sent: null,
    Last_Email_Sent: null,
    IsConfirmed: false,
    APPOINTMENT_REVIEWSTARS: 0,
    APPOINTMENT_FEEDBACK: null,
    APPOINTMENT_CREATION_DATE: "",
    SOURCE:""
  };

  const initialState = {
    errorMessage: null,
    errored: false,
  };

  const handleCloseSnackbar = () => {
    setState({ ...snackbarState, open: false });
  };
  const [] = React.useState(initialState);
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = () => {
    //setOpendialog(true);
  };
  //FB 8917
  let patType = state.appointmentdetails.patientType;
  const [snackbarState, setState] = React.useState<SnackBarState>({
    open: false,
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal, open } = snackbarState;
  //FB 6752
  const handleEmailCheckbox = async (e: any) => {
    if (e.target.checked) {
      setEmailPref(1);
    }
    else {
      setEmailPref(0);
    }
  }

  const handleTextCheckbox = async (e: any) => {
    if (e.target.checked) {
      setTextPref(1);
    }
    else {
      setTextPref(0);
    }
  }

  //FB 7675
  var timeZone = "America/Port-au-Prince";
  var userTimeZone = sessionStorage.getItem("TimeZone");
  if (userTimeZone != null) {
    timeZone = userTimeZone;
  }

  //FB 7675
  var convertedSlot = ConvertTimeZone(state.slotDetails.slotDate.toDateString(), state.slotDetails.slotDate.toTimeString(), timeZone, "datetime");

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Snackbar
          style={{ marginBottom: 50 }}  //FB 4678
          autoHideDuration={10000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}   //FB 4678
          open={open}
          onClose={handleCloseSnackbar}
          // message={minutesLeft}
          key={vertical + horizontal}
        >
          <Alert id="sessionAlert" severity="info">
            {minutesLeft != 0
              ? minutesLeft + " minute(s) left"
              : "your session has expired!"}
          </Alert>
        </Snackbar>
      </div>
      <div>
        <section style={{ margin: "10px 20px 20px" }}>
          <Grid container direction="row">
            <Grid
              item
              xs={12}
              alignContent="center"
              justify="center"
              style={{ display: "flex" }}
            >
              {/*FB 4867 DK - Styling changes*/}
              <Typography
                id="summaryInofficeMessage"
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  display:
                    state.appointmentdetails.appointmenttype === "inoffice"
                      ? "flex"
                      : "none",
                  fontSize: "16px",
                }}
              >
                <p>
                  {"You are booking an in-office appointment with "}&nbsp;
                  <b>
                    {/* FB 4574 DK - Removed "Dr." string */}
                    {/* FB 7675 */}
                    {
                      state.slotDetails.employeeName +
                      " on " +
                      new Date(convertedSlot).toLocaleString('en-US', dateOptions) +
                      " at " +
                      state.appointmentdetails.location.name}
                  </b>
                </p>
              </Typography>
              {/*FB 4867 DK - Styling changes*/}
              <Typography
                variant="h6"
                id="summaryTeledermMessage"
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  display:
                    state.appointmentdetails.appointmenttype === "telederm"
                      ? "flex"
                      : "none",
                }}
              >
                <p>
                  {"You are booking a " +
                    globalsettings.digitalApptType.toLowerCase() +
                    " appointment with "}
                  &nbsp;
                  <b>
                    {/* FB 4574 DK - Removed "Dr." string */}
                    {/* FB 7675 */}
                    {
                      state.slotDetails.employeeName +
                      " on " +
                      new Date(convertedSlot).toLocaleString(
                        "en-US",
                        dateOptions
                      )}
                  </b>
                </p>
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              lg={12}
              md={12}
              sm={12}
              xs={12}
              direction="column"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                id="titleMessage"
                variant="h6"
                style={{ color: "gray" }}
              >
                <b>Please fill out your details</b>
              </Typography>

              <Typography
                variant="subtitle1"
                id="sessionMessage"
                style={{ color: "maroon", fontWeight: "bold" }}
              >
                {minutesLeft != 0
                  ? "Your session will be active for next " +
                  minutesLeft +
                  " minute(s)"
                  : "Your session has expired!"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{
                display: displayMessage,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h5 id="existingPatientMessage" style={{ color: "red" }}>
                We could not find your record, please enter other details and
                book the appointment
              </h5>
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{
                display: displayVerfiedMessage,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                id="verifiedMessage"
                variant="h6"
                style={{ color: "red" }}
              >
                Verified. You can go ahead and book the appointment
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* FB 7719 */}
              <TextField
                name="firstName"
                id="firstName"
                onChange={(e) => handleFirstNameChange(e)}
                style={{ fontSize: "6px", width: 250 }}
                label="First Name *"
                inputRef={register({
                  required: true,
                  pattern: /^[A-Za-z0-9 ]+$/i,
                })}
                autoCapitalize="none"
                disabled={disableFields}
                helperText={firstNameMessage}
                value={FirstName}
                error={firstNameError}
              />
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* FB 7719 */}
              <TextField
                name="lastName"
                id="lastName"
                onChange={(e) => handleLastNameChange(e)}
                style={{ fontSize: "6px", width: 250 }}
                inputRef={register({
                  required: true,
                  pattern: /^[A-Za-z0-9]+$/i,
                })}
                autoCapitalize="none"
                disabled={disableFields}
                helperText={lastNameMessage}
                value={LastName}
                error={lastNameError}
                label="Last Name *"
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              md={6}
              sm={12}
              lg={6}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* FB 4371 : Bindu:Start - Below date control has been changed for the dat of birth field*/}
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    id="dob"
                    inputVariant="standard"
                    orientation="portrait"
                    label="Date of Birth *"
                    style={{ width: 250 }}    //FB 4574 DK - Added width
                    value={dateforDOBfield}		//FB 4499 DK - Changed the variable which contain unformatted date to avoid format failures
                    onChange={(date) => handleDOBChange(date)}
                    format="MM/dd/yyyy"
                    maxDate={new Date()}
                    initialFocusedDate={null}
                    helperText={DOBMessage}
                    error={DOBError}
                    disabled={disableFields}    //FB 4409 DK - Added to disable the DOB field after existing patient verified
                    className={classes.iconCSS} //FB 4574 DK - Added styling for icon
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
              {/* FB 4371 : Bindu:End - Below date control has been changed for the dat of birth field*/}
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sm={12}
              lg={6}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ThemeProvider theme={theme}>
                <FormControl error={GenderError}>
                  <InputLabel shrink>Gender *</InputLabel>
                  <NativeSelect
                    className={classes.dropdown_nomargin}
                    style={{ width: 250 }}    //FB 4574 DK - Removed px from width
                    name="gender"
                    id="gender"
                    value={Gender}
                    onChange={handleGenderChange}
                    disabled={disableFields}
                    error={GenderError}
                  >
                    <option value={0}></option>
                    <option value={1}>Male</option>
                    <option value={2}>Female</option>
                    <option value={3}>Unknown</option>		//FB 4567 DK - Modified gender option from 'Other' to 'Unknown'
                  </NativeSelect>
                  <FormHelperText>{genderMessage}</FormHelperText>
                </FormControl>
              </ThemeProvider>
            </Grid>
          </Grid>
          <div style={{ display: displayvalue }}>
            <Grid container spacing={1}>
              <Grid
                item
                lg={6}
                md={6}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TextField
                  name="email"
                  id="email"
                  onChange={(e) => handleEmailChange(e)}
                  style={{ fontSize: "6px", width: 250 }}
                  error={emailError}
                  disabled={disableFields}
                  helperText={emailMessage}
                  label="Email *"
                  value={Email}
                />
              </Grid>

              <Grid
                item
                lg={6}
                md={6}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TextField
                  name="cellPhone"
                  id="cellPhone"
                  onChange={(e) => handleCellPhoneChange(e)}
                  style={{ fontSize: "6px", width: 250 }}
                  error={CellPhoneError}
                  disabled={disableFields}
                  autoCapitalize="none"
                  helperText={CellPhoneMessage}
                  label="Cell Phone *"
                  inputProps={{ maxLength: 14 }}  //FB-4867
                  value={CellPhone}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid
                item
                lg={6}
                md={6}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TextField
                  name="address"
                  id="address"
                  onChange={(e) => handleAddressChange(e)}
                  style={{ fontSize: "6px", width: 250 }}
                  error={AddressError}
                  disabled={disableFields}
                  helperText={AddressMessage}
                  label="Address *"
                  value={Address}
                />
              </Grid>

              <Grid
                item
                lg={6}
                md={6}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TextField
                  name="city"
                  id="city"
                  autoCapitalize="none"
                  onChange={(e) => handleCityChange(e)}
                  style={{ fontSize: "6px", width: 250 }}
                  error={CityError}
                  disabled={disableFields}
                  helperText={CityMessage}
                  label="City *"
                  value={City}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid
                item
                xs={12}
                md={6}
                sm={12}
                lg={6}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                }}
              >
                <ThemeProvider theme={theme}>
                  <FormControl error={StatesError}>
                    <InputLabel shrink htmlFor="state-native-label-placeholder">
                      State *
                    </InputLabel>
                    <NativeSelect
                      className={classes.dropdown_nomargin}
                      style={{ width: 250 }}    //FB 4574 DK - Removed px from width
                      name="states"
                      id="states"
                      value={statename}
                      onChange={handleStateChange}
                      error={StatesError}
                      disabled={disableFields}
                      inputProps={{
                        name: "states",
                        id: "states-native-label-placeholder",
                      }}
                    >
                      <option value={0}></option>
                      {state.states.map((name: any) => (
                        <option value={name.name}>{name.name}</option>
                      ))}
                    </NativeSelect>
                    <FormHelperText>{stateMessage}</FormHelperText>
                  </FormControl>
                </ThemeProvider>
              </Grid>

              <Grid
                item
                lg={6}
                md={6}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TextField
                  name="zipCode"
                  id="zipCode"
                  onChange={(e) => handleZipCodeChange(e)}
                  style={{ fontSize: "6px", width: 250 }}
                  helperText={validationObj.postalCodeMessage}
                  error={validationObj.postalCodeError}
                  label="Postal/Zip code *"
                  autoCapitalize="none"
                  disabled={disableFields}
                  inputProps={{ maxLength: 5 }}
                  value={ZipCode}
                />
              </Grid>
            </Grid>
          </div>
          {/* FB 6752 - Start */}
          <Grid container spacing={1}>
            <Grid
              item
              lg={7}
              md={7}
              sm={12}
              xs={12}
              style={{
                display: state.appointmentdetails.patientType === "new" || showPref ? "flex" : "none",
                alignItems: "center",
                justifyContent: "center",
                color: "dimgrey",
                paddingLeft: "20px"
              }}
            >
              <Typography>
                Communication Preference
              </Typography>
              <FormGroup style={{ paddingLeft: "10px" }}>
                <FormControlLabel control={<Checkbox checked={emailPref == 1 ? true : false} name="email" onChange={handleEmailCheckbox} style={{ color: "#18a2b8" }} />} label="E-Mail" />
              </FormGroup>
              <FormGroup>
                <FormControlLabel control={<Checkbox checked={textPref == 1 ? true : false} name="text" onChange={handleTextCheckbox} style={{ color: "#18a2b8" }} />} label="Text" />
              </FormGroup>
            </Grid>
          </Grid>
          {/* FB 6752 - End */}

            {/* FB 4574 DK - Removed unneccasary code */}
			{/* FB 9538 changed the display style */}
            <Grid container spacing={1}>
              <Grid
                item
                lg={12}
                sm={12}
                xs={12}
                md={12}
                style={{
                  display: enableReasonForAppt && (state.appointmentdetails.patientType === "new" || showPref) ? "flex" : "none",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* FB 7719 */}
                <TextField
                  name="comments"
                  id="comments"
                  onChange={(e) => handleCommentChange(e)} //FB 9538
                  style={{ width: 845 }}
				  //FB 9538 start
                  error={CommentError} 
                  label="Reason for your appointment*"    
                  helperText={CommentMessage}
				  //FB 9538 end
                  value={Comments}
                />
              </Grid>
            </Grid>
          {/* FB 6752 */}
          <br />
          {/* FB 4574 DK - Added mandatory fields note - Start */}
          <Grid container spacing={2}>
            <Grid item xs={9} sm={4} md={4}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <span style={{ color: "red" }}>* Mandatory fields</span>
            </Grid>
          </Grid>
          {/* FB 4574 DK - Added mandatory fields note - End */}
          <br />
          {/* FB 8917 */}
          <Grid
            container
            spacing={2}
            className={styles.flexend_Grid}
          >
            <Grid
              item
              xs={6}
              sm={6}
              md={2}
              lg={2}
              style={{ display: verifydisplay }}
              className={styles.flexend_Grid}
            >
              {/* FB 7719 */}
              {/* FB 9396 */}
              <Button
                onClick={buttonclick}
                variant="contained"
                className={classes.active}
                type="submit"
                id="verify"
                disabled={disableFields}
              >
                {buttonVerifyText}
              </Button>
            </Grid>
            <Grid item xs={7} sm={6} md={3} className={styles.flexend_Grid}>
              {/* FB 7719 */}
              {/* FB 8917 */}
              <Button
                style={{ display: disablebutton }}
                variant="contained"
                className={styles.navigationButton}
                type="submit"
                id="bookAppointment"
                disabled={btnDisable}
                onClick={bookApptButtonClick}
              >
                {buttonText}
              </Button>
            </Grid>
            <Grid
              item
              xs={5}
              sm={6}
              md={2}
              lg={2}
              // style={{
              //   display: "flex",
              //   justifyContent: "flex-end",
              //   alignItems: "center",
              // }}
              className={styles.flexend_Grid}
            >
              <Button
                onClick={handleGoBack}
                variant="contained"
                id="goBackdemo"
                className={classes.active}
              >
                Go Back
              </Button>
            </Grid>
          </Grid>
          <Dialog
            onClose={handleClose}
            maxWidth={"xs"}
            id="validationDialog"
            aria-labelledby="customized-dialog-title"
            open={openDialog}
          >
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
              Maximum Appointments
            </DialogTitle>
            <DialogContent dividers>
			  {/* FB 9505 included scheduler phoe number */}
              <Typography style={{ fontSize: "14px" }} gutterBottom>
                You have already booked an appointment for this date. If you
                need to book an additional appointment, please contact the
                office at {state.appointmentdetails.location.phone}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                className={classes.active}
                onClick={handleClose}
              //href="/appointment/create"
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            onClose={handleCloseDialog}
            maxWidth={"xs"}
            id="existingPatientDialog"
            aria-labelledby="customized-dialog-title"
            open={openValidationDialog}
          >
            <DialogContent dividers>
              <Typography style={{ fontSize: "14px" }} gutterBottom>
                We found this user in our records! We will proceed with the
                existing details.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                className={classes.active}
                onClick={handleCloseDialog}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
          {/* FB 4780 BR-Start In PE, Getting Email/Cell for Existing Patients */}
          <Dialog
            onClose={handleCloseDialog}
            maxWidth={"xs"}
            id="existingPatientDialog"
            aria-labelledby="customized-dialog-title"
            open={openValidationDialog}
          >
            <DialogContent dividers>
              <Typography style={{ fontSize: "14px" }} gutterBottom>
                We found this user in our records! We will proceed with the
                existing details.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                className={classes.active}
                onClick={handleCloseDialog}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            onClose={handleClose}
            fullWidth={true}
            maxWidth={"xs"}
            id="updateEmailCellphone"
            aria-labelledby="customized-dialog-title"
            open={openUpdateEmailDialog}
          >
            <DialogTitle id="customized-dialog-title" onClose={handleDialogClose}>
              <Typography variant="h6" style={{ fontFamily: "Bold" }}>Please confirm your details</Typography>

            </DialogTitle>
            <DialogContent dividers>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TextField
                  name="email"
                  id="email"
                  onChange={(e) => handlePatientEmailChange(e)}
                  style={{ fontSize: "6px", width: 300 }}
                  error={emailError}
                  helperText={emailMessage}
                  label="Email *"
                  value={patientEmail}
                />
              </Grid>
              <br />
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TextField
                  name="cellPhone"
                  id="cellPhone"
                  onChange={(e) => handlePatientCellPhoneChange(e)}
                  style={{ fontSize: "6px", width: 300 }}
                  error={CellPhoneError}
                  autoCapitalize="none"
                  helperText={CellPhoneMessage}
                  label="Cell Phone *"
                  inputProps={{ maxLength: 14 }}  //FB-4867
                  value={patientCellPhone}
                />
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid container>
                <Grid item xs={12} sm={6} md={6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                  <span style={{ color: "red" }}>* Mandatory fields</span>
                </Grid>
              </Grid>
              <Button
                variant="contained"
                className={classes.active}
                onClick={updateEmailCellPhoneButton}
              //href="/appointment/create"
              >
                Update/Confirm
              </Button>
            </DialogActions>
          </Dialog>
          {/* FB 4780 BR In PE, Getting Email/Cell for Existing Patients */}
        </section>
      </div>
    </form>
  );
}
